export default __webpack_public_path__ + "static/media/17.9df9bbdb.webp";